"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartWearableFilter = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Checkbox_1 = require("../Checkbox/Checkbox");
var SmartBadge_1 = require("../SmartBadge");
var Box_1 = require("../Box");
var Media_1 = require("../Media");
require("./SmartWearableFilter.css");
var SmartWearableFilter = function (props) {
    var isOnlySmart = props.isOnlySmart, onChange = props.onChange, i18n = props.i18n, className = props.className, _a = props.defaultCollapsed, defaultCollapsed = _a === void 0 ? false : _a;
    var _b = i18n || {}, _c = _b.title, title = _c === void 0 ? 'Smart' : _c, _d = _b.selected, selected = _d === void 0 ? 'Only Smart' : _d;
    var isMobileOrTablet = (0, Media_1.useTabletAndBelowMediaQuery)();
    var handleChange = (0, react_1.useCallback)(function (_, props) {
        onChange(!!props.checked);
    }, [onChange]);
    var header = (0, react_1.useMemo)(function () { return (react_1.default.createElement("div", { className: "dui-smart-wearable-filter__header" }, isMobileOrTablet ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: "dui-smart-wearable-filter__name" }, title),
        isOnlySmart ? (react_1.default.createElement("span", { className: "dui-smart-wearable-filter__value" }, selected)) : null)) : (title))); }, [selected, isMobileOrTablet, isOnlySmart]);
    return (react_1.default.createElement(Box_1.Box, { header: header, className: (0, classnames_1.default)('dui-smart-wearable-filter', className), collapsible: true, defaultCollapsed: defaultCollapsed || isMobileOrTablet },
        react_1.default.createElement("div", { className: "dui-smart-wearable-filter__content", "data-testid": props['data-testid'] },
            react_1.default.createElement(SmartBadge_1.SmartBadge, { clickable: false, i18n: i18n }),
            react_1.default.createElement(Checkbox_1.Checkbox, { toggle: true, checked: !!isOnlySmart, onChange: handleChange }))));
};
exports.SmartWearableFilter = SmartWearableFilter;
